import * as React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { red } from "@mui/material/colors";
import FavoriteBorder from "@mui/icons-material/FavoriteBorder";
import Favorite from "@mui/icons-material/Favorite";
import Checkbox from "@mui/material/Checkbox";
import { Avatar } from "@mui/material";
import Snackbar, { SnackbarOrigin } from "@mui/material/Snackbar";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { addFavoriteItem } from "../../../services/core-api";
import { useSnackbar } from "../SnackbarContext";

interface State extends SnackbarOrigin {
  openNotification: boolean;
}

const ProductOffer = (props: any) => {
  const [checked, setChecked] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();
  const { product } = props;
  const defaultImage = "./no-image.png";
  const productPrice = Number(product.price) || 0; // Fallback to 0 if price is not a number
  const price = productPrice.toFixed(2);
  const [isFavoriteItem, setIsFavoriteItem] = React.useState<Boolean | null>(null);

  React.useEffect(() => {
    // Simulate a network request to fetch product data
    const timer = setTimeout(() => {
      setLoading(false);
    }, 2000); // Adjust the timeout as needed
  
    return () => clearTimeout(timer); // Cleanup the timeout
  }, [checked, product, product.productId]); // Add props.id to the dependency array

  // Toggle the checked state when the heart icon is clicked
  const handleCheckboxChange = (event: React.MouseEvent, product: any) => {
    event.stopPropagation(); // Prevent card click when clicking favorite
    setChecked(!checked);
    if(product) {
      (async () => {
        try {
          const favoriteItem = {
            product_id: product.productId ?? product.id,
            favorite_id: 0,
            articleNumber: product.articleNumber,
            mfrName: product.mfrName,
            dataSupplierId: product.dataSupplierId,
            internalNumber: product.internalNumber,
            image: product.image ? product.image : "",
            description: product.description ? product.description : "",
            quantity: 1,
            price: product.price,
            totalPrice: product.price,
            available: true
          };
          await addFavoriteItem(favoriteItem);
          showSnackbar("Produkt wurde zu den Favoriten hinzugefügt.", "success");
          setIsFavoriteItem((prev) => !prev);
        }catch(error){
          showSnackbar("Produkt konnte nicht zu den Favoriten hinzugefügt werden.", "error");
        }
      })()
    }
  };

    // Navigate to product detail page
    const navigateToProduct = (product: any) => {
      const dataSupplierId = product.dataSupplierId;
      const articleNumber = product.articleNumber;
      
      // Navigate to product detail page with product ID and article number
      navigate(`/search-products?keyword=${articleNumber}&brand=${dataSupplierId}`);
    };



  return (
    <>
      {loading ? (
        <>
          <Skeleton variant="rectangular" sx={{width: '90%', height: '100px'}} />
          <Box sx={{ pt: 0.5 }}>
            <Skeleton sx={{width: '90%', height: '10px'}} />
            <Skeleton width="60%" />
          </Box>
        </>
      ) : (
        <Card
          sx={{
            maxWidth: 225,
            border: "7px solid #f1f1f1",
            borderRadius: "0",
            boxShadow: "none",
            cursor: "pointer", // Add pointer cursor to indicate clickable
            "&:hover": {
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)", // Add hover effect
            },
          }}
          onClick={() => navigateToProduct(product)}
        >
          <CardHeader
          />
          <CardMedia
            component="img"
            sx={{
              height: '180px',
              width: 'auto',
              margin: '0 auto',      
              display: 'block',      
              objectFit: 'contain',  
              maxHeight: '180px',  
              maxWidth: '180px'
            }}
            image={product.image || defaultImage}
            alt="Produktbild"
          />
          <CardContent>
            <Typography variant="body2" color="black">
              {product.manufacturer_name ?? product.mfrName ?? ""}
            </Typography>
            <Typography variant="body2" color="black">
              {product.articleNumber}
            </Typography>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default ProductOffer;
